import React from 'react';
import { palette } from '../styles/theme';
import { Popper, Paper, Stack, ButtonBase, Typography, Box } from '@mui/material';

const CustomPopper = ({ state, anchorElement, items }) => {
    const { popperOpen, setPopperOpen } = state;

    return (
        <Popper
            open={popperOpen}
            anchorEl={anchorElement}
            placement="right"
            onMouseEnter={() => setPopperOpen(true)}
            onMouseLeave={() => setPopperOpen(false)}
        >
            <Paper sx={{ marginLeft: '6px', boxShadow: '10px 2px 14.2px -6px rgba(0, 0, 0, 0.25)' }}>
                <Stack paddingY={'8px'} gap={'16px'} alignItems={'flex-start'}>

                    {items?.map(item => (
                        <ButtonBase className={item.active ? 'popper_item--active' : 'popper_item'} key={item.label} onClick={item.onClick}>
                            <Box>
                                {item.icon}
                            </Box>
                            <Typography variant='span' color={item.active ? 'white' : palette.disabled[950]}>{item.label}</Typography>
                        </ButtonBase>
                    ))}
                </Stack>
            </Paper>
        </Popper>

    );
};

export default CustomPopper;
